import { QuestionCircleOutlined } from '@ant-design/icons';
import { useTranslate } from '@tolgee/react';
import { Form, FormProps, Input, Radio, Space, Tooltip } from 'antd';
import { AuthByDomainBody, TokopediaStoreType } from 'services/api/tokopedia';

export interface TokoRegForm2Value extends AuthByDomainBody {}

export interface TokoRegForm2Props extends FormProps<TokoRegForm2Value> {}

const TokoRegForm2 = ({ ...props }: TokoRegForm2Props) => {
  const { t } = useTranslate();

  return (
    <Form<TokoRegForm2Value>
      layout="horizontal"
      autoComplete="off"
      preserve={false}
      labelCol={{ span: 5 }}
      wrapperCol={{ span: 16 }}
      {...props}
    >
      <Form.Item
        name="storeName"
        label={t('ViewShops.店铺名称')}
        rules={[
          {
            type: 'string',
            required: true,
            message: t('Entities.请输入') + t('ViewShops.店铺名称'),
          },
        ]}
      >
        <Input placeholder={t('Entities.请输入')} />
      </Form.Item>
      <Form.Item
        name="domain"
        label={
          <Space>
            {t('translation.商店域名')}
            <Tooltip title={`${t('marketing.示例')}: www.tokopedia.com/domai`}>
              <QuestionCircleOutlined />
            </Tooltip>
          </Space>
        }
        rules={[
          {
            type: 'string',
            required: true,
            message: `${t('Entities.请输入')}${t('translation.商店域名')}`,
          },
        ]}
      >
        <Input placeholder={t('Entities.请输入')} />
      </Form.Item>
      <Form.Item
        name="storeType"
        label={<Space>{t('ViewShops.店铺类型')}</Space>}
        rules={[{ required: true }]}
      >
        <Radio.Group>
          <Radio value={TokopediaStoreType.旗舰店}>{t('translation.旗舰店')}</Radio>
          <Radio value={TokopediaStoreType.会员店}>{t('translation.会员店')}</Radio>
        </Radio.Group>
      </Form.Item>
    </Form>
  );
};
export default TokoRegForm2;
